import React, { useState, useMemo } from 'react';

function fmtMan(n) { return Math.round((n || 0) / 10000).toLocaleString(); }

function DashboardWidgets(props) {
  var t = props.t;
  var isRTL = props.isRTL;
  var pipeline = props.pipeline;
  var stats = props.stats;
  var total = props.total;
  var FLOW = props.FLOW;
  var FLOW_COLOR = props.FLOW_COLOR;
  var FLOW_ICON = props.FLOW_ICON;
  var FLOW_LABELS = props.FLOW_LABELS;
  var smartAlerts = props.smartAlerts;
  var alertCounts = props.alertCounts;
  var expandedGroup = props.expandedGroup;
  var setExpandedGroup = props.setExpandedGroup;
  var showDismissed = props.showDismissed;
  var setShowDismissed = props.setShowDismissed;
  var dismissedAlerts = props.dismissedAlerts;
  var isDismissed = props.isDismissed;
  var dismissAlert = props.dismissAlert;
  var restoreAlert = props.restoreAlert;
  var deadlineCounts = props.deadlineCounts;
  var deadlineItems = props.deadlineItems;
  var customsLoading = props.customsLoading;
  var setCustomsLoading = props.setCustomsLoading;
  var customsResult = props.customsResult;
  var setCustomsResult = props.setCustomsResult;
  var navigate = props.navigate;
  var buyerPayments = props.buyerPayments;
  var monthlyData = props.monthlyData;
  var chartMax = props.chartMax;
  var recentDeposits = props.recentDeposits || { days: [] };
  var depositsDays = props.depositsDays || 30;
  var setDepositsDays = props.setDepositsDays || function() {};
  var arrivalSoonCars = Array.isArray(props.arrivalSoonCars) ? props.arrivalSoonCars : [];
  var notices = Array.isArray(props.notices) ? props.notices : [];
  var dismissedNotices = props.dismissedNotices;
  var setDismissedNotices = props.setDismissedNotices;
  var now = props.now;
  var user = props.user;
  var lang = props.lang;
  var changeLang = props.changeLang;

  var levelStyle={
    urgent:{bg:'#fef2f2',border:'#fecaca',text:'#dc2626',label:t.urgent},
    warn:{bg:'#fffbeb',border:'#fef08a',text:'#ca8a04',label:t.warning},
    info:{bg:'#eff6ff',border:'#bfdbfe',text:'#2563eb',label:t.info}
  };

  var paymentStatusColor={'완납':'#10b981','잔금대기':'#f59e0b','중도금':'#3b82f6','미입금':'#ef4444'};

  var greeting=(function(){var h=now.getHours();if(h<6)return t.lateNight;if(h<12)return t.goodMorning;if(h<18)return t.goodAfternoon;return t.goodEvening})();

  var maxCount=Math.max.apply(null,FLOW.map(function(f){return pipeline[f]||0}).concat([1]));

  return (<>
    {/* ── 인사 + 요약 스트립 ── */}
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
      <div>
        <h2 style={{margin:0,fontSize:22,fontWeight:800,color:'#0f172a'}}>{greeting}, {user.name}{t.sir}</h2>
        <p style={{margin:'4px 0 0',fontSize:13,color:'#64748b'}}>{now.toLocaleDateString(lang==='ar'?'ar-SA':'ko-KR',{year:'numeric',month:'long',day:'numeric',weekday:'long'})}</p>
      </div>
      <div style={{display:'flex',gap:12,alignItems:'center'}}>
        <select value={lang} onChange={function(e){changeLang(e.target.value)}} style={{fontSize:11,padding:'3px 8px',border:'1px solid #d0d5dd',borderRadius:6,background:'#fff',cursor:'pointer'}}>
          <option value="ko">한국어</option>
          <option value="ar">العربية</option>
        </select>
        <div style={{background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:10,padding:'10px 18px',textAlign:'center'}}>
          <div style={{fontSize:22,fontWeight:800,color:'#2563eb'}}>{total}</div>
          <div style={{fontSize:10,color:'#64748b',fontWeight:600}}>{t.totalVehicles}</div>
        </div>
        <div style={{background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:10,padding:'10px 18px',textAlign:'center'}}>
          <div style={{fontSize:22,fontWeight:800,color:'#16a34a'}}>{stats.thisMonthCount}</div>
          <div style={{fontSize:10,color:'#64748b',fontWeight:600}}>{t.thisMonthProcessed}</div>
        </div>
        <div style={{background:'#fefce8',border:'1px solid #fef08a',borderRadius:10,padding:'10px 18px',textAlign:'center'}}>
          <div style={{fontSize:22,fontWeight:800,color:'#ca8a04'}}>{smartAlerts.length}</div>
          <div style={{fontSize:10,color:'#64748b',fontWeight:600}}>{t.alertsLabel}</div>
        </div>
        {(deadlineCounts.expired>0||deadlineCounts.urgent>0)&&<div style={{background:'#fef2f2',border:'1px solid #fecaca',borderRadius:10,padding:'10px 18px',textAlign:'center',cursor:'pointer'}} onClick={function(){navigate('/main/car-list',{state:{filter:'기한임박'}})}}>
          <div style={{fontSize:22,fontWeight:800,color:'#dc2626'}}>{(deadlineCounts.expired||0)+(deadlineCounts.urgent||0)}</div>
          <div style={{fontSize:10,color:'#dc2626',fontWeight:600}}>{t.deadlineApproach}</div>
        </div>}
        {props.reportSummary&&<div style={{background:'#faf5ff',border:'1px solid #e9d5ff',borderRadius:10,padding:'10px 18px',textAlign:'center',cursor:'pointer'}} onClick={function(){navigate('/main/report')}}>
          <div style={{fontSize:22,fontWeight:800,color:'#7c3aed'}}>{fmtMan(props.reportSummary.profit)}</div>
          <div style={{fontSize:10,color:'#64748b',fontWeight:600}}>이번달 순이익(만)</div>
        </div>}
      </div>
    </div>

    {/* ── 수출기한 초과 배너 ── */}
    {deadlineCounts.expired>0&&<div style={{background:'linear-gradient(135deg,#dc2626,#b91c1c)',color:'#fff',padding:'14px 24px',borderRadius:12,marginBottom:16,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer',boxShadow:'0 4px 16px rgba(220,38,38,0.3)'}} onClick={function(){navigate('/main/car-list',{state:{filter:'기한임박'}})}}>
      <div style={{display:'flex',alignItems:'center',gap:10}}>
        <span style={{fontSize:20}}>🚨</span>
        <span style={{fontWeight:800,fontSize:15}}>{t.exportExpired} {deadlineCounts.expired}{t.penaltyWarning}</span>
      </div>
      <span style={{fontSize:13,opacity:0.8,fontWeight:600}}>{t.immediateCheck}</span>
    </div>}

    {/* ═══ 공지사항 배너 ═══ */}
    {notices.filter(function(n){return dismissedNotices.indexOf(n.id)===-1}).map(function(n){
      var ps={info:{bg:'#eff6ff',bl:'#3b82f6',c:'#1e40af',icon:'🔵'},warning:{bg:'#fffbeb',bl:'#f59e0b',c:'#92400e',icon:'🟡'},urgent:{bg:'#fef2f2',bl:'#ef4444',c:'#991b1b',icon:'🔴'}};
      var s=ps[n.priority]||ps.info;
      return(<div key={n.id} style={{background:s.bg,borderLeft:'4px solid '+s.bl,borderRadius:8,padding:'10px 16px',marginBottom:10,display:'flex',alignItems:'center',gap:10}}>
        <span style={{fontSize:16}}>{s.icon}</span>
        <div style={{flex:1}}>
          <div style={{fontWeight:700,fontSize:13,color:s.c}}>{n.title}</div>
          {n.content&&<div style={{fontSize:12,color:'#666',marginTop:2}}>{n.content}</div>}
        </div>
        <span style={{fontSize:10,color:'#94a3b8',whiteSpace:'nowrap'}}>{(n.createdAt||'').slice(0,10)}</span>
        <button onClick={function(){var updated=dismissedNotices.concat(n.id);setDismissedNotices(updated);try{sessionStorage.setItem('dismissed_notices',JSON.stringify(updated))}catch(e){}}} style={{background:'none',border:'none',fontSize:14,cursor:'pointer',color:'#94a3b8',padding:2}}>✕</button>
      </div>);
    })}

    {/* ═══ 1. 파이프라인 뷰 ═══ */}
    <div className="card" style={{padding:20,marginBottom:16}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.pipeline}</h3>
        <button style={{padding:'6px 16px',borderRadius:8,fontSize:12,fontWeight:700,border:'1px solid #0ea5e9',background:customsLoading?'#e0f2fe':'#f0f9ff',color:'#0369a1',cursor:customsLoading?'default':'pointer',transition:'all .2s'}} onClick={function(){
          if(customsLoading)return;setCustomsLoading(true);setCustomsResult(null);
          (props.authFetch||fetch)(props.API+'/customs/check-all',{method:'POST'}).then(function(r){return r.json()}).then(function(d){
            setCustomsLoading(false);setCustomsResult(d);
            if(d.shippedCount>0){window.location.reload()}
          }).catch(function(){setCustomsLoading(false)});
        }}>{customsLoading?'🔄 '+t.checking:'🚢 '+t.checkShipping}</button>
      </div>
      {customsResult&&<div style={{background:customsResult.shippedCount>0?'#dcfce7':'#f0f9ff',border:'1px solid '+(customsResult.shippedCount>0?'#86efac':'#bae6fd'),borderRadius:8,padding:10,marginBottom:12,fontSize:12}}>
        {t.customsResult}: {customsResult.total}{t.searched} → <b style={{color:'#059669'}}>{customsResult.shippedCount}{t.shippedConfirm}</b>
        {customsResult.results&&customsResult.results.filter(function(r){return r.shipped}).map(function(r){return(<span key={r.carId} style={{marginLeft:8,background:'#22c55e',color:'#fff',padding:'1px 6px',borderRadius:4,fontSize:11}}>{r.carNo} {r.tkofDate}</span>)})}
      </div>}
      <div style={{display:'flex',gap:6,alignItems:'stretch',direction:'ltr'}}>
        {FLOW.map(function(f,i){
          var cnt=pipeline[f]||0;
          var pct=total>0?Math.round(cnt/total*100):0;
          var isLast=i===FLOW.length-1;
          return(<div key={f} style={{flex:1,position:'relative',cursor:'pointer'}} onClick={function(){navigate('/main/car-list',{state:{filter:f}})}}>
            <div style={{background:cnt>0?FLOW_COLOR[i]+'12':'#f8fafc',border:'2px solid '+(cnt>0?FLOW_COLOR[i]+'40':'#e5e7eb'),borderRadius:12,padding:'16px 8px',textAlign:'center',transition:'all .2s',height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
              <div style={{fontSize:22,marginBottom:4}}>{FLOW_ICON[i]}</div>
              <div style={{fontSize:26,fontWeight:800,color:cnt>0?FLOW_COLOR[i]:'#cbd5e1',lineHeight:1}}>{cnt}</div>
              <div style={{fontSize:10,color:'#64748b',fontWeight:600,marginTop:6,lineHeight:1.2}}>{FLOW_LABELS[i]}</div>
              {cnt>0&&<div style={{fontSize:9,color:FLOW_COLOR[i],fontWeight:700,marginTop:4}}>{pct}%</div>}
            </div>
            {!isLast&&<div style={{position:'absolute',right:-8,top:'50%',transform:'translateY(-50%)',zIndex:2,fontSize:12,color:'#cbd5e1'}}>→</div>}
          </div>);
        })}
      </div>
      <div style={{display:'flex',gap:2,marginTop:10,borderRadius:6,overflow:'hidden',direction:'ltr'}}>
        {FLOW.map(function(f,i){var cnt=pipeline[f]||0;var w=total>0?(cnt/total*100):14.28;return(<div key={f} style={{height:6,width:w+'%',background:FLOW_COLOR[i],transition:'width .5s'}}></div>)})}
      </div>
    </div>

    {/* ═══ 2행: 스마트 알림 + 수출기한 임박 ═══ */}
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
      {/* 스마트 알림 */}
      <div className="card" style={{padding:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.smartAlerts}</h3>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            {dismissedAlerts.length>0&&<span style={{fontSize:11,color:showDismissed?'#2563eb':'#94a3b8',cursor:'pointer',textDecoration:'underline'}} onClick={function(){setShowDismissed(!showDismissed)}}>{showDismissed?t.hideDismissed:t.dismissedAlerts+' '+dismissedAlerts.length+t.items}</span>}
            <span style={{fontSize:12,color:'#64748b',fontWeight:600}}>{smartAlerts.filter(function(a){return!isDismissed(a.id)}).length}{t.items}</span>
          </div>
        </div>
        {smartAlerts.length>0&&<div style={{display:'flex',gap:8,marginBottom:14}}>
          {alertCounts.urgent>0&&<span style={{fontSize:10,fontWeight:700,color:'#dc2626',background:'#fef2f2',padding:'3px 10px',borderRadius:6}}>🔴 {t.urgent} {alertCounts.urgent}</span>}
          {alertCounts.warn>0&&<span style={{fontSize:10,fontWeight:700,color:'#ca8a04',background:'#fefce8',padding:'3px 10px',borderRadius:6}}>🟡 {t.warning} {alertCounts.warn}</span>}
          {alertCounts.info>0&&<span style={{fontSize:10,fontWeight:700,color:'#2563eb',background:'#eff6ff',padding:'3px 10px',borderRadius:6}}>🔵 {t.info} {alertCounts.info}</span>}
        </div>}
        <div style={{maxHeight:320,overflowY:'auto'}}>
          {smartAlerts.filter(function(a){return!isDismissed(a.id)}).length===0&&!showDismissed&&<div style={{color:'#94a3b8',fontSize:13,padding:20,textAlign:'center'}}>{t.noAlerts}</div>}
          {smartAlerts.filter(function(a){return showDismissed||!isDismissed(a.id)}).map(function(a){
            var ls=levelStyle[a.level]||levelStyle.info;
            var dismissed=isDismissed(a.id);
            var isGroup=a.groupCars&&a.groupCars.length>0;
            var isExpanded=expandedGroup===a.id;
            return(<div key={a.id} style={{opacity:dismissed?0.45:1}}>
              <div style={{display:'flex',alignItems:'center',gap:10,padding:'10px 12px',borderRadius:8,marginBottom:isExpanded?0:5,background:dismissed?'#f1f5f9':ls.bg,border:'1px solid '+(dismissed?'#e2e8f0':ls.border),borderBottom:isExpanded?'1px dashed '+ls.border:'1px solid '+(dismissed?'#e2e8f0':ls.border),borderBottomLeftRadius:isExpanded?0:8,borderBottomRightRadius:isExpanded?0:8,cursor:'pointer',transition:'all .15s'}} onClick={function(){
                if(isGroup){setExpandedGroup(isExpanded?null:a.id)}
                else if(a.carNo){navigate('/main/car-list',{state:{search:a.carNo}})}
              }}>
                <span style={{fontSize:15,flexShrink:0}}>{a.icon}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:600,color:dismissed?'#94a3b8':'#1e293b',lineHeight:1.4}}>{a.text}</div>
                  {a.carNo&&<div style={{fontSize:10,color:'#94a3b8',marginTop:1}}>{a.carType}</div>}
                </div>
                <span style={{fontSize:9,fontWeight:700,color:dismissed?'#94a3b8':ls.text,background:dismissed?'#e2e8f0':ls.text+'18',padding:'2px 8px',borderRadius:4,flexShrink:0}}>{dismissed?t.dismiss:ls.label}</span>
                {isGroup&&<span style={{fontSize:11,color:'#94a3b8',flexShrink:0,marginLeft:2}}>{isExpanded?'▲':'▼'}</span>}
                {dismissed?<span style={{fontSize:14,color:'#3b82f6',cursor:'pointer',flexShrink:0,lineHeight:1}} title={t.restore} onClick={function(ev){ev.stopPropagation();restoreAlert(a.id)}}>↩</span>
                :<span style={{fontSize:14,color:'#999',cursor:'pointer',flexShrink:0,lineHeight:1}} title={t.dismiss} onClick={function(ev){ev.stopPropagation();dismissAlert(a.id)}} onMouseEnter={function(ev){ev.currentTarget.style.color='#333'}} onMouseLeave={function(ev){ev.currentTarget.style.color='#999'}}>✕</span>}
              </div>
              {isGroup&&isExpanded&&<div style={{background:ls.bg,border:'1px solid '+ls.border,borderTop:'none',borderRadius:'0 0 8px 8px',padding:'4px 12px 8px',marginBottom:5}}>
                {a.groupCars.map(function(gc){
                  return(<div key={gc.id} style={{display:'flex',alignItems:'center',gap:8,padding:'5px 8px',borderRadius:4,marginTop:3,background:gc.shippedAt?'#f0fdf4':'#fff',cursor:'pointer',fontSize:11}} onClick={function(){navigate('/main/car-list',{state:{search:gc.carNo}})}}>
                    <span style={{fontWeight:600,color:'#334155'}}>{gc.carNo}</span>
                    {gc.vin&&<span style={{fontFamily:'monospace',fontSize:9,color:'#64748b'}}>{gc.vin}</span>}
                    <span style={{marginLeft:'auto',color:'#94a3b8',fontSize:10,flexShrink:0}}>{gc.shippedAt||gc.carType||gc.status||''}</span>
                  </div>);
                })}
              </div>}
            </div>);
          })}
        </div>
      </div>

      {/* 수출기한 임박 차량 */}
      <div className="card" style={{padding:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.exportDeadline}</h3>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            {deadlineCounts.expired>0&&<span style={{fontSize:10,fontWeight:700,color:'#dc2626',background:'#fef2f2',padding:'2px 8px',borderRadius:4}}>{t.exceed} {deadlineCounts.expired}</span>}
            {deadlineCounts.urgent>0&&<span style={{fontSize:10,fontWeight:700,color:'#ea580c',background:'#fff7ed',padding:'2px 8px',borderRadius:4}}>{t.urgent} {deadlineCounts.urgent}</span>}
            {deadlineCounts.warning>0&&<span style={{fontSize:10,fontWeight:700,color:'#ca8a04',background:'#fefce8',padding:'2px 8px',borderRadius:4}}>{t.warning} {deadlineCounts.warning}</span>}
            <span style={{fontSize:10,color:'#94a3b8'}}>{t.cancelPlus270}</span>
          </div>
        </div>
        <div style={{maxHeight:320,overflowY:'auto'}}>
          {deadlineItems.length===0&&<div style={{color:'#94a3b8',fontSize:13,padding:20,textAlign:'center'}}>{t.noDeadlineVehicles}</div>}
          {deadlineItems.length>0&&<div style={{display:'flex',padding:'6px 12px',fontSize:10,fontWeight:700,color:'#64748b',borderBottom:'2px solid #e2e8f0',marginBottom:4,direction:'ltr'}}>
            <div style={{width:28}}></div>
            <div style={{flex:2}}>{t.vehicle}</div>
            <div style={{flex:1,textAlign:'center'}}>{t.dDay}</div>
            <div style={{flex:1,textAlign:'center'}}>{t.cancelDate}</div>
            <div style={{flex:1,textAlign:'center'}}>{t.deadlineDate}</div>
            <div style={{flex:1,textAlign:'center'}}>{t.status}</div>
          </div>}
          {deadlineItems.map(function(item,i){
            var c=item.car;
            var d=item.daysLeft;
            var lv=item.level;
            var bgMap={expired:'#fef2f2',urgent:'#fff7ed',warning:'#fefce8',normal:'#f8fafc'};
            var borderMap={expired:'#fecaca',urgent:'#fed7aa',warning:'#fef08a',normal:'#e5e7eb'};
            var textMap={expired:'#dc2626',urgent:'#ea580c',warning:'#ca8a04',normal:'#16a34a'};
            var dotIcon=lv==='expired'?'🔴':lv==='urgent'?'🔴':lv==='warning'?'🟡':'🟢';
            var dText=d<0?'+'+Math.abs(d)+' '+t.daysExceeded:'D-'+d;
            var cancelDate=(c.cancel_completed_at||'').slice(0,10);
            var deadlineDate=(item.deadline||'').slice(0,10);
            var tagText=lv==='expired'?t.exceed:lv==='urgent'?t.urgent:lv==='warning'?t.warning:t.margin;
            return(<div key={c.id} style={{display:'flex',alignItems:'center',padding:'9px 12px',borderRadius:8,marginBottom:4,background:bgMap[lv],border:'1px solid '+borderMap[lv],cursor:'pointer',transition:'all .15s',direction:'ltr'}} onClick={function(){navigate('/main/car-list',{state:{search:c.carNo}})}}>
              <div style={{width:28,flexShrink:0,fontSize:14}}>{dotIcon}</div>
              <div style={{flex:2,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:12,color:'#1e293b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.carNo}</div>
                <div style={{fontSize:10,color:'#94a3b8',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.carType}</div>
              </div>
              <div style={{flex:1,textAlign:'center'}}>
                <span style={{fontWeight:800,fontSize:14,color:textMap[lv]}}>{dText}</span>
              </div>
              <div style={{flex:1,textAlign:'center',fontSize:11,color:'#64748b',fontFamily:'monospace'}}>{cancelDate||'-'}</div>
              <div style={{flex:1,textAlign:'center',fontSize:11,color:'#64748b',fontFamily:'monospace'}}>{deadlineDate||'-'}</div>
              <div style={{flex:1,textAlign:'center'}}>
                <span style={{fontSize:9,fontWeight:700,color:textMap[lv],background:textMap[lv]+'18',padding:'2px 10px',borderRadius:4}}>{tagText}</span>
              </div>
            </div>);
          })}
        </div>
      </div>
    </div>

    {/* ═══ 3행: 바이어 입금현황 + 월간 실적 차트 ═══ */}
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
      {/* 바이어 입금현황 */}
      <div className="card" style={{padding:20}}>
        <h3 style={{margin:'0 0 14px',fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.buyerPayment}</h3>
        <div style={{maxHeight:300,overflowY:'auto'}}>
          {buyerPayments.map(function(b,i){
            var pct=b.total>0?Math.round(b.paid/b.total*100):0;
            var sc=paymentStatusColor[b.status]||'#64748b';
            var overdueDays=0;
            var overdueRef='';
            if(b.status==='미입금'&&b.invoiceDate){overdueDays=Math.floor((Date.now()-new Date(b.invoiceDate).getTime())/86400000);overdueRef='invoiceDate'}
            else if(b.status==='잔금대기'&&b.lastPaidDate){overdueDays=Math.floor((Date.now()-new Date(b.lastPaidDate).getTime())/86400000);overdueRef='lastPaidDate'}
            var isOverdue=overdueDays>7;
            var isWarning=overdueDays>=3&&overdueDays<=7;
            var borderColor=isOverdue?'#fca5a5':isWarning?'#fed7aa':'#e5e7eb';
            var statusLabel=t[b.statusKey]||b.status;
            return(<div key={i} style={{padding:'12px 14px',borderRadius:10,marginBottom:8,background:'#fff',border:'2px solid '+borderColor,cursor:b.buyerId?'pointer':'default',transition:'background 0.15s'}} onClick={b.buyerId?function(){navigate('/main/car-list',{state:{buyerId:b.buyerId}})}:undefined} onMouseEnter={b.buyerId?function(e){e.currentTarget.style.background='#f8fafc'}:undefined} onMouseLeave={b.buyerId?function(e){e.currentTarget.style.background='#fff'}:undefined}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                  <span style={{fontSize:16}}>{b.country==='AE'?'🇦🇪':b.country==='KZ'?'🇰🇿':b.country==='UZ'?'🇺🇿':b.country==='KG'?'🇰🇬':'🌍'}</span>
                  <div>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <span style={{fontWeight:700,fontSize:16,color:'#1e293b'}}>{b.name}{b.tel?' ('+b.tel+')':''}</span>
                      {isOverdue&&<span style={{fontSize:11,fontWeight:600,color:'#DC2626',background:'#FEE2E2',padding:'2px 8px',borderRadius:4}}>⚠️ D+{overdueDays} {t.overdueDay}</span>}
                      {isWarning&&<span style={{fontSize:11,fontWeight:600,color:'#D97706',background:'#FEF3C7',padding:'2px 8px',borderRadius:4}}>{t.needConfirm}</span>}
                    </div>
                    <div style={{fontSize:11,color:'#94a3b8',display:'flex',alignItems:'center',gap:6}}><span>미수 {b.cars}{t.vehicles}</span>{b.earliestDate&&(function(){var days=Math.floor((Date.now()-new Date(b.earliestDate).getTime())/86400000);return(<span style={{fontSize:10,fontWeight:600,color:days>14?'#dc2626':days>7?'#d97706':'#64748b'}}>판매 D+{days}</span>)})()}</div>
                  </div>
                </div>
                <span style={{fontSize:13,fontWeight:700,color:sc,background:sc+'18',padding:'4px 12px',borderRadius:6}}>{statusLabel}</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',fontSize:14,color:'#64748b',marginBottom:4}}>
                <span><span style={{fontWeight:700,color:'#dc2626'}}>미수금 {(b.balance||0).toLocaleString()}만원</span><span style={{fontSize:12,fontWeight:500,marginLeft:8}}>입금 {b.paid.toLocaleString()} / {b.total.toLocaleString()}만원</span></span>
                <span style={{fontWeight:700,color:sc}}>{pct}%</span>
              </div>
              <div style={{background:'#f1f5f9',borderRadius:4,height:6,overflow:'hidden'}}>
                <div style={{height:'100%',background:sc,borderRadius:4,width:pct+'%',transition:'width .5s'}}></div>
              </div>
            </div>);
          })}
        </div>
      </div>

      {/* 도착예정차량 (오늘~+7일) — 차량 클릭 시 차량목록 carNo 검색 진입 */}
      <div className="card" style={{padding:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>도착예정 차량</h3>
          <span style={{fontSize:11,color:'#64748b'}}>오늘~+7일 · 미도착</span>
        </div>
        {arrivalSoonCars.length===0 ? (
          <div style={{padding:'30px 0',textAlign:'center',color:'#94a3b8',fontSize:13}}>도착예정 차량이 없습니다 ✨</div>
        ) : (
          <div style={{maxHeight:300,overflowY:'auto'}}>
            {arrivalSoonCars.map(function(c){
              var dep=(c.departure_date||'').slice(0,10);
              var kstNow=new Date(Date.now()+9*3600*1000);
              var kstToday=kstNow.toISOString().slice(0,10);
              var tm=new Date(kstNow);tm.setDate(tm.getDate()+1);
              var kstTomorrow=tm.toISOString().slice(0,10);
              var label,bg,fg;
              if(dep===kstToday){label='오늘 출발';bg='#fef2f2';fg='#dc2626'}
              else if(dep===kstTomorrow){label='내일 출발';bg='#fff7ed';fg='#ea580c'}
              else{var days=Math.ceil((new Date(dep+'T00:00:00+09:00')-new Date(kstToday+'T00:00:00+09:00'))/86400000);label='D-'+days;bg='#eff6ff';fg='#2563eb'}
              return(<div key={c.id} style={{padding:'10px 12px',borderRadius:8,marginBottom:6,background:'#fff',border:'1px solid #e5e7eb',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}} onClick={function(){navigate('/main/car-list',{state:{search:c.carNo}})}}>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#1e293b'}}>🚛 {c.carNo||'-'} <span style={{fontSize:11,fontWeight:500,color:'#64748b',marginLeft:6}}>{c.carType||''}</span></div>
                  {c.departure_memo?<div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>{c.departure_memo}</div>:null}
                </div>
                <span style={{fontSize:11,fontWeight:700,color:fg,background:bg,padding:'4px 10px',borderRadius:6,whiteSpace:'nowrap'}}>{label}</span>
              </div>);
            })}
          </div>
        )}
      </div>

    </div>

    {/* 월간 실적 차트 (별도 full-width 행) */}
    <div style={{marginBottom:16}}>
      <div className="card" style={{padding:20}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>{t.monthlyPerf}</h3>
          <div style={{display:'flex',gap:12,fontSize:11}}>
            <span style={{display:'flex',alignItems:'center',gap:4}}><span style={{width:10,height:10,borderRadius:3,background:'#3b82f6',display:'inline-block'}}></span>{t.revenue}({t.revenueUnit})</span>
            <span style={{display:'flex',alignItems:'center',gap:4}}><span style={{width:10,height:10,borderRadius:3,background:'#94a3b8',display:'inline-block'}}></span>{t.purchase}({t.revenueUnit})</span>
            <span style={{display:'flex',alignItems:'center',gap:4}}><span style={{width:10,height:10,borderRadius:3,background:'#22c55e',display:'inline-block'}}></span>{t.netProfit}({t.profitUnit})</span>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'flex-end',gap:12,height:200,padding:'0 4px',direction:'ltr'}}>
          {monthlyData.map(function(d,i){
            var isCurrentMonth=i===monthlyData.length-1;
            return(<div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:0}}>
              <div style={{flex:1,display:'flex',alignItems:'flex-end',gap:3,width:'100%',justifyContent:'center'}}>
                <div style={{width:'28%',background:isCurrentMonth?'linear-gradient(180deg,#2563eb,#3b82f6)':'#3b82f6',borderRadius:'4px 4px 0 0',height:Math.max(d['\uB9E4\uCD9C']/chartMax*150,4),transition:'height .5s',position:'relative'}}>
                  <span style={{position:'absolute',top:-16,left:'50%',transform:'translateX(-50%)',fontSize:10,fontWeight:700,color:'#3b82f6',whiteSpace:'nowrap'}}>{d['\uB9E4\uCD9C']?Number(d['\uB9E4\uCD9C']).toLocaleString():0}</span>
                </div>
                <div style={{width:'28%',background:'#cbd5e1',borderRadius:'4px 4px 0 0',height:Math.max(d['\uB9E4\uC785']/chartMax*150,4),transition:'height .5s',position:'relative'}}>
                  <span style={{position:'absolute',top:-16,left:'50%',transform:'translateX(-50%)',fontSize:10,fontWeight:700,color:'#94a3b8',whiteSpace:'nowrap'}}>{d['\uB9E4\uC785']?Number(d['\uB9E4\uC785']).toLocaleString():0}</span>
                </div>
                <div style={{width:'28%',background:isCurrentMonth?'linear-gradient(180deg,#16a34a,#22c55e)':'#22c55e',borderRadius:'4px 4px 0 0',height:Math.max(Math.abs(d['\uC21C\uC775']||0)/chartMax*150,4),transition:'height .5s',position:'relative'}}>
                  <span style={{position:'absolute',top:-16,left:'50%',transform:'translateX(-50%)',fontSize:10,fontWeight:700,color:(d['\uC21C\uC775']||0)>=0?'#22c55e':'#dc2626',whiteSpace:'nowrap'}}>{d['\uC21C\uC775']?Number(d['\uC21C\uC775']).toLocaleString():0}</span>
                </div>
              </div>
              <div style={{fontSize:11,fontWeight:isCurrentMonth?800:600,color:isCurrentMonth?'#1e293b':'#94a3b8',marginTop:8,paddingTop:6,borderTop:'1px solid #e5e7eb',width:'100%',textAlign:'center'}}>{d.month}</div>
            </div>);
          })}
        </div>
      </div>
    </div>
    {/* ═══ 일별 입금 내역 (증거기록 테이블, Wave 4 — 2026-05-16) ═══ */}
    <DepositsTable recentDeposits={recentDeposits} depositsDays={depositsDays} setDepositsDays={setDepositsDays} API={props.API} authFetch={props.authFetch} />
  </>);
}

// ═══ 입금 내역 일별 accordion — 분쟁 증거 빠른 조회 ═══
function DepositsTable(props) {
  var recentDeposits = props.recentDeposits || { days: [] };
  var depositsDays = props.depositsDays || 30;
  var setDepositsDays = props.setDepositsDays || function() {};
  var [query, setQuery] = useState('');
  var [expandedDates, setExpandedDates] = useState({});  // { '2026-05-16': true }
  var [page, setPage] = useState(1);
  var perPage = 10;  // 10일/페이지

  // 일별 그룹 빌드 + 첫 차종 미리보기
  var days = useMemo(function() {
    return (recentDeposits.days || []).map(function(day) {
      var entries = day.entries || [];
      // 그 날 모든 allocations 모음 → 첫 차종 추출 + 차종 수
      var allAllocs = [];
      entries.forEach(function(e) { (e.allocations || []).forEach(function(a) { allAllocs.push(a); }); });
      var firstCarType = (allAllocs[0] && allAllocs[0].carType) || (allAllocs[0] && allAllocs[0].carNo) || '';
      var carCount = allAllocs.length;
      return {
        date: day.date, weekday: day.weekday, total: day.total || 0,
        entries: entries,
        count: entries.length,
        firstCarType: firstCarType,
        carCount: carCount
      };
    });
  }, [recentDeposits]);

  var grandTotal = days.reduce(function(s, d) { return s + d.total; }, 0);
  var grandCount = days.reduce(function(s, d) { return s + d.count; }, 0);

  // 검색 — 그 날의 어떤 entry/alloc 하나라도 매칭되면 그 날 표시 + 자동 펼침
  var filteredDays = useMemo(function() {
    var q = (query || '').trim().toLowerCase();
    if (!q) return days;
    return days.filter(function(d) {
      if ((d.date || '').indexOf(q) >= 0) return true;
      return (d.entries || []).some(function(e) {
        if ((e.buyerName || '').toLowerCase().indexOf(q) >= 0) return true;
        if ((e.memo || '').toLowerCase().indexOf(q) >= 0) return true;
        if ((e.createdBy || '').toLowerCase().indexOf(q) >= 0) return true;
        return (e.allocations || []).some(function(a) {
          if ((a.carNo || '').toLowerCase().indexOf(q) >= 0) return true;
          if ((a.vin || '').toLowerCase().indexOf(q) >= 0) return true;
          if ((a.carType || '').toLowerCase().indexOf(q) >= 0) return true;
          return false;
        });
      });
    });
  }, [days, query]);

  var filteredTotal = filteredDays.reduce(function(s, d) { return s + d.total; }, 0);
  var filteredCount = filteredDays.reduce(function(s, d) { return s + d.count; }, 0);
  var totalPages = Math.max(1, Math.ceil(filteredDays.length / perPage));
  var safePage = Math.min(page, totalPages);
  var pageDays = filteredDays.slice((safePage - 1) * perPage, safePage * perPage);

  React.useEffect(function() { setPage(1); }, [query, depositsDays]);

  // 검색 시 매칭된 날 자동 펼침
  React.useEffect(function() {
    if (!query) return;
    var auto = {};
    filteredDays.forEach(function(d) { auto[d.date] = true; });
    setExpandedDates(auto);
  }, [query]);

  var toggleDate = function(date) {
    setExpandedDates(function(prev) {
      var next = Object.assign({}, prev);
      if (next[date]) delete next[date]; else next[date] = true;
      return next;
    });
  };

  return (<div style={{marginBottom:16}}>
    <div className="card" style={{padding:20}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12,flexWrap:'wrap',gap:8}}>
        <div>
          <h3 style={{margin:0,fontSize:15,fontWeight:700,color:'#0f172a'}}>💰 입금 내역 (증거기록)</h3>
          <div style={{fontSize:11,color:'#64748b',marginTop:2}}>날짜 클릭 시 그 날 상세 펼침 · 검색 시 자동 펼침</div>
        </div>
        <div style={{display:'flex',gap:4}}>
          {[7,30,90].map(function(n){
            var active=depositsDays===n;
            return(<button key={n} onClick={function(){setDepositsDays(n)}} style={{padding:'6px 12px',borderRadius:6,fontSize:12,fontWeight:active?700:500,border:'1px solid '+(active?'#2563eb':'#d0d5dd'),background:active?'#2563eb':'#fff',color:active?'#fff':'#334155',cursor:'pointer'}}>{n}일</button>);
          })}
        </div>
      </div>
      <div style={{display:'flex',gap:8,marginBottom:10,flexWrap:'wrap',alignItems:'center'}}>
        <input
          type="text" placeholder="🔍 바이어, 차량번호, 차대번호(VIN), 차종, 메모, 날짜 검색..."
          value={query} onChange={function(e){setQuery(e.target.value)}}
          style={{flex:1,minWidth:240,padding:'8px 12px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:13}}
        />
        <span style={{fontSize:12,color:'#64748b'}}>
          <b style={{color:'#16a34a'}}>{filteredCount}</b>건 · <b style={{color:'#16a34a'}}>{filteredDays.length}</b>일 · 합계 <b style={{color:'#16a34a'}}>{fmtMan(filteredTotal)}</b>만원
          {query && grandCount !== filteredCount && <span style={{color:'#94a3b8'}}> (전체 {grandCount}건 / {fmtMan(grandTotal)}만원)</span>}
        </span>
      </div>
      {filteredDays.length===0?(
        <div style={{textAlign:'center',padding:32,color:'#94a3b8',fontSize:13}}>
          {query?'검색 결과 없음':'최근 '+depositsDays+'일간 입금 내역 없음'}
        </div>
      ):(<>
        <div>
          {pageDays.map(function(day){
            var isOpen = !!expandedDates[day.date];
            return(<div key={day.date} style={{border:'1px solid #e5e7eb',borderRadius:8,marginBottom:6,overflow:'hidden'}}>
              {/* 일별 요약 행 — 클릭 시 토글 */}
              <div onClick={function(){toggleDate(day.date)}} style={{cursor:'pointer',padding:'10px 14px',background:isOpen?'#f0f9ff':'#fff',display:'flex',alignItems:'center',gap:12,transition:'background .15s',userSelect:'none'}}>
                <span style={{color:'#64748b',fontSize:12,width:14,textAlign:'center'}}>{isOpen?'▼':'▶'}</span>
                <div style={{minWidth:120}}>
                  <span style={{fontWeight:700,fontSize:13,color:'#1e293b'}}>{day.date}</span>
                  <span style={{color:'#94a3b8',fontWeight:500,fontSize:11,marginLeft:6}}>({day.weekday})</span>
                </div>
                <div style={{flex:1,fontSize:12,color:'#475569'}}>
                  <b style={{color:'#0f172a'}}>{day.firstCarType||'-'}</b>
                  {day.carCount>1&&<span style={{color:'#94a3b8',marginLeft:4}}>외 {day.carCount-1}대</span>}
                </div>
                <div style={{fontSize:12,color:'#64748b'}}>{day.count}건</div>
                <div style={{fontWeight:800,color:'#16a34a',fontSize:14,minWidth:120,textAlign:'right'}}>+{fmtMan(day.total)}만원</div>
              </div>
              {/* 펼침 — 그 날 entries */}
              {isOpen&&<div style={{padding:'10px 14px',borderTop:'1px solid #e5e7eb',background:'#fafbfc'}}>
                {day.entries.map(function(e,ei){
                  // allocation_type 별 색상/라벨
                  var t = e.allocationType || 'manual';
                  var style;
                  if (t === 'contract') {
                    style = { bg:'#eff6ff', border:'#bfdbfe', amount:'#2563eb', name:'#1e40af', tag:'📝 계약금', tagBg:'#dbeafe', tagColor:'#1e40af' };
                  } else if (t === 'auto_fifo') {
                    style = { bg:'#ecfeff', border:'#a5f3fc', amount:'#0891b2', name:'#0f172a', tag:'🎯 자동배분', tagBg:'#cffafe', tagColor:'#0e7490' };
                  } else {
                    // manual (잔금/일괄완불 등 기본) — legacy 잔여 행도 여기 (#360: 경고 표시 폐기)
                    style = { bg:'#fff', border:'#e5e7eb', amount:'#16a34a', name:'#0f172a', tag:'💰 잔금', tagBg:'#dcfce7', tagColor:'#166534' };
                  }
                  return(<div key={ei} style={{padding:'8px 10px',background:style.bg,border:'1px solid '+style.border,borderRadius:6,marginBottom:6}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',marginBottom:4,gap:8,flexWrap:'wrap'}}>
                      <div style={{display:'flex',alignItems:'center',gap:6}}>
                        <span style={{fontSize:10,fontWeight:700,padding:'2px 7px',borderRadius:10,background:style.tagBg,color:style.tagColor,whiteSpace:'nowrap'}}>{style.tag}</span>
                        <span style={{fontWeight:700,color:style.name,fontSize:13}}>{e.buyerName}</span>
                      </div>
                      <div style={{fontWeight:800,color:style.amount,fontSize:14}}>+{fmtMan(e.amount)}만원</div>
                    </div>
                    <div style={{fontSize:11,color:'#475569',display:'flex',gap:12,flexWrap:'wrap',alignItems:'center'}}>
                      {(e.allocations||[]).map(function(a,ai){return(<div key={ai} style={{whiteSpace:'nowrap'}}>
                        <b style={{color:'#0f172a'}}>{a.carNo||'#'+a.carId}</b>
                        {a.carType&&<span style={{color:'#475569',marginLeft:4}}>{a.carType}</span>}
                        {a.vin&&<span style={{fontFamily:'Courier New, monospace',color:'#94a3b8',fontSize:10,marginLeft:4}}>{a.vin}</span>}
                        <span style={{color:'#94a3b8',fontSize:10,marginLeft:4}}>({fmtMan(a.amount)}만)</span>
                      </div>);})}
                    </div>
                    {(e.memo||e.createdBy)&&<div style={{display:'flex',gap:12,marginTop:4,fontSize:11,color:'#94a3b8'}}>
                      {e.memo&&<span style={{fontStyle:'italic',color:'#475569'}}>"{e.memo}"</span>}
                      {e.createdBy&&<span>by {e.createdBy}</span>}
                    </div>}
                  </div>);
                })}
              </div>}
            </div>);
          })}
        </div>
        {totalPages>1&&<div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:6,marginTop:12}}>
          <button onClick={function(){setPage(Math.max(1,safePage-1))}} disabled={safePage<=1} style={{padding:'4px 10px',borderRadius:5,border:'1px solid #d0d5dd',background:safePage<=1?'#f8fafc':'#fff',color:safePage<=1?'#cbd5e1':'#334155',cursor:safePage<=1?'default':'pointer',fontSize:12}}>◀ 이전</button>
          <span style={{fontSize:12,color:'#64748b'}}>{safePage} / {totalPages}</span>
          <button onClick={function(){setPage(Math.min(totalPages,safePage+1))}} disabled={safePage>=totalPages} style={{padding:'4px 10px',borderRadius:5,border:'1px solid #d0d5dd',background:safePage>=totalPages?'#f8fafc':'#fff',color:safePage>=totalPages?'#cbd5e1':'#334155',cursor:safePage>=totalPages?'default':'pointer',fontSize:12}}>다음 ▶</button>
        </div>}
      </>)}
    </div>
  </div>);
}

export default DashboardWidgets;
